import { ChapterAudioDetail } from 'src/interfaces'

const normalizeVariant = (value?: string | null) =>
	value?.toLowerCase().trim().replace(/_/g, '-') ?? ''

export const findAudioDetailForRegenerate = (
	audioDetails: ChapterAudioDetail[] | undefined,
	bookAudioId: string,
	languageVariant?: string | null,
	language?: string | null,
): ChapterAudioDetail | null => {
	if (!audioDetails?.length || !bookAudioId) return null

	const normalizedVariant = normalizeVariant(languageVariant)
	const normalizedLanguage = normalizeVariant(language)

	const exact = audioDetails.find((item) => {
		if (item.id !== bookAudioId) return false
		if (normalizedVariant) {
			return normalizeVariant(item.language_variant) === normalizedVariant
		}
		if (normalizedLanguage) {
			return normalizeVariant(item.language) === normalizedLanguage
		}
		return true
	})

	return exact ?? audioDetails.find((item) => item.id === bookAudioId) ?? null
}

export const buildRegenerateAudioPayload = (
	detail: ChapterAudioDetail,
): {
	action: 'regenerate_audio'
	book_audio_id: string
} => ({
	action: 'regenerate_audio',
	book_audio_id: detail.id,
})

export const buildRegenerateTextPayload = (
	detail: ChapterAudioDetail,
): {
	action: 'regenerate_text'
	book_audio_id: string
} => ({
	action: 'regenerate_text',
	book_audio_id: detail.id,
})
